import React from "react";
import { AGENTIC_ASSET_URL } from "constants/aicc";
import styles from "./LearningAssets.module.scss";

function AgenticAssetLink() {
  return (
    <a className={styles.agenticAssetLink} href={AGENTIC_ASSET_URL} target="_blank" rel="noopener noreferrer">
      Go To Agentic Asset
    </a>
  );
}

export default AgenticAssetLink;
